<template>
  <div class="row">
    <div class="col-md-12 card mt-3">
      <div class="card-header">
        <div class="category">Schéma prémontage</div>
        <!--          <div class="text-right mb-3">-->
        <!--            <p-button @click="" class="mt-3" type="primary">Ajouter Utilisateur</p-button>-->
        <!--          </div>-->
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
            <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Recherche"
                      v-model="query"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" :data="table" border @sort-change="sortChange" :emptyText="emptyText">
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px"/>
            </div>
            <el-table-column label="Miniature">
              <template v-slot="{ row }">
                <img v-on:click='openPdf(row.attributes.pdf)' v-if="row.attributes.miniature"
                     :src="'data:image/jpeg;base64,'+row.attributes.miniature || '/img/default.png'" class=""/>
              </template>
            </el-table-column>
            <el-table-column label="référence" prop="attributes.reference" sortable="custom"/>
            <el-table-column label="Description" prop="attributes.description" sortable="custom"/>
            <!--              <el-table-column-->
            <!--                  label="Status"-->
            <!--                  prop="roles.name"-->
            <!--                  sortable="custom"-->
            <!--              >-->
            <!--                <template v-slot="{ row }">-->
            <!--&lt;!&ndash;                  <span>{{(row.roles[0].name == 'member')?'membre': row.roles[0].name}}</span>&ndash;&gt;-->
            <!--                </template>-->
            <!--              </el-table-column>-->
            <!--              <el-table-column-->
            <!--                  label="Créer le"-->
            <!--                  prop="created_at"-->
            <!--                  sortable="custom"-->
            <!--              />-->
            <!--              <el-table-column-->
            <!--                  fixed="right"-->
            <!--                  class-name="td-actions"-->
            <!--                  label="Actions">-->
            <!--                <template slot-scope="props">-->
            <!--&lt;!&ndash;                  <p-button type="success" size="sm" icon @click="goToEdit(props.row.id)">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <i class="fa fa-edit"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;                  </p-button>&ndash;&gt;-->
            <!--&lt;!&ndash;                  <p-button type="danger" size="sm" icon @click="destroy(props.row.id)">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <i class="fa fa-times"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;                  </p-button>&ndash;&gt;-->
            <!--                </template>-->
            <!--              </el-table-column>-->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category"> {{ from + 1 }} / {{ to }} sur {{ total }} schémas</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import router from "../../main";
import _ from 'lodash';
import {Table, TableColumn, Select, Option} from 'element-ui';
import PPagination from 'src/components/UIComponents/Pagination.vue'
import swal from "sweetalert2";

const url = process.env.VUE_APP_API_BASE_URL;
const media = process.env.VUE_APP_MEDIA_BASE_URL;
import axios from 'axios';

export default {

  data() {
    return {
      loading: true,
      table: [],
      footerTable: ["Name", "Created At", "Actions"],
      base_media: media,
      query: null,
      emptyText: 'Aucun plan',
      sort: "created_at",

      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25],
      },

      total: 0,
      options: {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json"
        }
      },
    }
  },
  components: {
    PPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: 'getListDebounced',
      immediate: true
    },
    pagination: {
      handler: 'getList',
      immediate: false,
      deep: true
    },
  },
  methods: {
    getListDebounced: _.debounce(function () {
      if (this.query == null || this.query.length > 4) {
        this.getList()
      }
    }, 300),

    async getList() {
      this.loading = true
      let params = {
        include: "roles",
        ...(this.sort ? {sort: this.sort} : {}),
        filter: {
          // ...(this.query ? {name: this.query} : {}),
          // ...(this.query ? {email: this.query} : {}),
          // ...(this.query ? {roles: this.query} : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage
        }
      }

      try {

        // await this.$store.dispatch("users/list", params)
        axios.get(`${url}/premontage-pdfs?` + ((this.query) ? `filter[recherche]=` + this.query + `%&` : ``) + `page[number]=` + this.pagination.currentPage + `&page[size]=` + this.pagination.perPage, this.options).then(response => {
          // console.log(response.data.data)
          this.table = response.data.data
          this.total = response.data.meta.page.total;
          this.loading = false
        });

        // this.total = this.$store.getters["users/listTotal"]

        this.loading = false
      } catch (e) {
        this.$notify({
          type: 'danger',
          message: "Oups, quelque chose s'est mal passé !",
          icon: 'nc-icon nc-bell-55',
        })
      }
    },

    async destroy(id) {
      if (this.$isDemo == 1 && ["1", "2", "3"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed to change data of default users.",
          icon: 'nc-icon nc-bell-55',
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: 'Are you sure?',
          text: `You won't be able to revert this!`,
          icon: 'warning',
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
            cancelButton: 'btn btn-danger btn-fill'
          },
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        })

        if (confirmation.value === true) {
          await this.$store.dispatch("users/destroy", id)
          this.$notify({
            type: 'success',
            message: 'User deleted successfully.',
            icon: 'nc-icon nc-bell-55',
          })
          await this.getList()
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: error.response.data.errors[0].title,
            icon: 'nc-icon nc-bell-55',
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oups, quelque chose s'est mal passé !",
            icon: 'nc-icon nc-bell-55',
          });
        }
      }
    },

    goToAdd() {
      this.$router.push({name: 'Add User'})
    },

    goToEdit(id) {
      this.$router.push({name: 'Edit User', params: {id}})
    },

    sortChange({prop, order}) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
    openPdf: function (pdf) {
      var byteCharacters = atob(pdf);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], {type: 'application/pdf;base64'});
      file.name = 'tyty';
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);

      // var pdf_newTab = window.open("");
      // pdf_newTab.document.write(
      //     "<html><head><title>your title in here</title></head><body><iframe title='MY title'  width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdf) + "'></iframe></body></html>"
      // );


    },
  },
  mounted() {
    const options = {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      }
    };
    // axios.get(`${url}/premontage-pdfs`, options)
    //     .then(response => {
    //         console.log(response)
    //     });
  },
  created() {


  }
}
</script>
<style>

</style>
